import Loader from 'react-loader-spinner';

export const Spinner = (props: { className?: string }): JSX.Element => {
	const { className = '' } = props;

	return (
		<div className={className}>
			<Loader
				type="TailSpin"
				color="#00BFFF"
				height={100}
				width={100}
			/>
		</div>
	);
};
